import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import moment from 'moment';

import { t, findLocale } from 'services/translation';
import {
  getSavedTimezone,
  timezoneCode,
  convertDateTimezone,
} from 'ui_system/utilities/timezoneUtils';

import { BrandLink } from 'views/plugins/confirmation/styles';
import MobileMixin from './mobile_mixin';
import { Location } from './location';
import { ConfirmationSection } from './pending';
import ConfirmEmail from './ConfirmEmail';
import AdditionalGuestsLink from './AdditionalGuestsLink.tsx';
import ExperienceLink from './ExperienceLink.tsx';

const ConfirmationAccepted = createReactClass({
  displayName: 'ConfirmationAccepted-Plugins',

  propTypes: {
    first_name: PropTypes.string.isRequired,
    brand_color: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    footer_content: PropTypes.node,
    ticketed_event: PropTypes.bool.isRequired,
    online: PropTypes.bool,
  },

  mixins: [MobileMixin, PureRenderMixin],

  _isLiveBooking() {
    const { is_live_booking } = this.props;
    return is_live_booking;
  },

  _renderDateReminder() {
    const { online, date, time, tourTimezone, isoTime } = this.props;

    let displayTime = time;
    const momentLocale = findLocale().slice(0, 2);
    const dateObject = moment(date, 'MMM DD, YYYY').locale(momentLocale);
    let displayDate = dateObject.format(t('DATE_FORMAT'));
    const timeFormat = isoTime ? 'HH:mm' : 'h:mm a';

    if (online) {
      let matchingTimezoneCode = null;
      const timezone = getSavedTimezone();
      const dateTime = convertDateTimezone({
        originalTimezone: tourTimezone,
        timezone,
        date: date.trim(),
        dateFormat: 'MMM DD, YYYY',
        time: time.replace(/\s+/g, ''),
        timeFormat: 'h:mma',
      });

      const displayMonth = dateTime.format('MMM');
      displayDate = `${t(displayMonth)} ${dateTime.format('DD, YYYY')}`;

      if (timezone) matchingTimezoneCode = timezoneCode(timezone);
      displayTime = `${dateTime.format(timeFormat)} (${matchingTimezoneCode})`;
    } else {
      displayTime = moment(time, 'h:mma').format(timeFormat);
    }

    displayTime = displayTime.replace(/am/g, t('AM')).replace(/pm/g, t('PM'));

    return (
      <ConfirmationSection
        dangerouslySetInnerHTML={{
          __html: t('WE_LOOK_FORWARD_TO_SEEING_YOU_ON', '', {
            date: displayDate,
            time: displayTime,
          }),
        }}
      />
    );
  },

  _renderTicketedText() {
    let weSentYou;
    let pleasePresent;
    const pluralize = this.props.has_multiple_tickets;
    if (pluralize) {
      weSentYou = t('WE_JUST_SENT_AN_EMAIL_TO_YOU_WITH_YOUR_TICKETS');
      pleasePresent = t('PLEASE_PRESENT_YOUR_TICKETS_WHEN_YOU_ARRIVE');
    } else {
      weSentYou = t('WE_JUST_SENT_AN_EMAIL_TO_YOU_WITH_YOUR_TICKET');
      pleasePresent = t('PLEASE_PRESENT_THIS_TICKET_WHEN_YOU_ARRIVE');
    }

    return (
      <div>
        <ConfirmationSection>
          {weSentYou}.<br />
          {pleasePresent}.
        </ConfirmationSection>
        <ConfirmEmail
          email={this.props.email}
          bookingIdHash={this.props.booking_id_hash}
          bookingId={this.props.booking_id}
          displayError={this.props.displayError}
          setEmail={this.props.setEmail}
        />
        {this._renderDateReminder()}
      </div>
    );
  },

  _renderDefaultText() {
    if (this._isLiveBooking()) return null;
    const { disable_guest_confirmation_email } = this.props;
    return (
      <div>
        {!!disable_guest_confirmation_email ? (
          <ConfirmationSection>
            {t('NO_RESERVATION_CODES_NO_TICKETS_TO_PRINT')}.
          </ConfirmationSection>
        ) : (
          <div>
            <ConfirmationSection>
              {t('WE_JUST_SENT_AN_EMAIL_TO_YOU_WITH_ALL_YOUR_DETAILS')}.<br />
              {t('NO_RESERVATION_CODES_NO_TICKETS_TO_PRINT')}.
            </ConfirmationSection>
            <ConfirmEmail
              email={this.props.email}
              bookingIdHash={this.props.booking_id_hash}
              bookingId={this.props.booking_id}
              displayError={this.props.displayError}
              setEmail={this.props.setEmail}
            />
          </div>
        )}
        {this._renderDateReminder()}
      </div>
    );
  },

  _renderAffiliateText() {
    return (
      <div>
        <ConfirmationSection>
          {t('WE_JUST_SENT_AN_EMAIL_TO_YOU_WITH_ALL_YOUR_DETAILS')}.
        </ConfirmationSection>
      </div>
    );
  },

  _renderAffiliateTitle() {
    const { affiliateName } = this.props;
    return (
      <div>
        <h1>
          <span className="titleRow">
            {t('THANK_YOU')}, {affiliateName}.
          </span>
          <span className="titleRow" data-testid="confirmed-booking">
            {t('YOUR_BOOKING_IS_CONFIRMED')}.
          </span>
        </h1>
      </div>
    );
  },

  _renderRegularBody() {
    const { ticketed_event, isBookingAffiliate } = this.props;
    let renderFunction;
    if (isBookingAffiliate) {
      renderFunction = this._renderAffiliateText();
    } else if (ticketed_event) {
      renderFunction = this._renderTicketedText();
    } else {
      renderFunction = this._renderDefaultText();
    }

    return (
      <div className="Confirmation-Body-Regular-Content">{renderFunction}</div>
    );
  },

  _renderTitle() {
    const { custom_title, isBookingAffiliate } = this.props;

    let renderFunction;
    if (isBookingAffiliate) {
      renderFunction = this._renderAffiliateTitle();
    } else if (custom_title) {
      renderFunction = this._renderCustomTitle(custom_title);
    } else {
      renderFunction = this._renderDefaultTitle();
    }

    return (
      <div className="Confirmation-Title" data-testid="tour-confirmation-title">
        {renderFunction}
      </div>
    );
  },

  _renderDefaultTitle() {
    return (
      <div>
        <h1>
          {this._isLiveBooking() ? (
            <>
              <span className="titleRow">
                {this.props.headline ||
                  `${t('THANK_YOU')}, ${this.props.first_name}.`}
              </span>
              <p
                dangerouslySetInnerHTML={{
                  __html: this.props.sub_headline || `${t('YOU_ARE_ALL_SET')}`,
                }}
              />
            </>
          ) : (
            <>
              <span className="titleRow">
                {t('THANK_YOU')}, {this.props.first_name}.
              </span>
              <span className="titleRow" data-testid="confirmed-booking">
                {t('YOUR_BOOKING_IS_CONFIRMED')}.
              </span>
            </>
          )}
        </h1>
      </div>
    );
  },

  _renderExperienceLink(bookingLanguage) {
    const {
      experience_link,
      canAdditionalGuestsLink,
      booking_id_hash: bookingIdHash,
    } = this.props;
    const {
      title,
      subtext,
      url,
      button_text,
      multi_guest_title,
      multi_guest_subtext,
      multi_guest_button_text,
    } = experience_link;
    return (
      <ExperienceLink
        title={title}
        subtext={subtext}
        url={url}
        buttonText={button_text}
        multiGuestTitle={multi_guest_title}
        multiGuestSubtext={multi_guest_subtext}
        multiGuestButtonText={multi_guest_button_text}
        multiGuestExperienceLink={
          canAdditionalGuestsLink && this.belowGuestLimit()
        }
        bookingIdHash={bookingIdHash}
        bookingLanguage={bookingLanguage}
      />
    );
  },

  _renderCustomTitle(customTitle) {
    return (
      <h1
        className="contains-brand-link"
        dangerouslySetInnerHTML={{ __html: customTitle } /* // nosemgrep */}
      />
    );
  },

  modifyBookingLink() {
    const {
      automatic_booking,
      guest_paid_invoice,
      guest_reschedulable,
      has_future_availability,
      brand_color,
      link_to_modify,
      isBookingAffiliate = false,
    } = this.props;

    const nonReschedulable =
      !guest_reschedulable ||
      (!automatic_booking && !guest_paid_invoice) ||
      !has_future_availability ||
      isBookingAffiliate;

    if (nonReschedulable) return null;
    return (
      <BrandLink
        target="_blank"
        className="modifyBookingLink brand-color"
        href={link_to_modify}
        data-testid="reschedule-booking"
      >
        {t('RESCHEDULE_BOOKING')} &rarr;
      </BrandLink>
    );
  },

  belowGuestLimit() {
    const { numberOfGuests, maxNumberGuests } = this.props;
    return maxNumberGuests === 0 ? true : numberOfGuests <= maxNumberGuests;
  },

  render() {
    const {
      custom_body,
      footer_content,
      location,
      custom_locations_enabled,
      online,
      experience_link,
      canAdditionalGuestsLink,
      AdditionalGuestsLinkSettings,
      booking_id_hash: bookingIdHash,
      isBookingAffiliate,
    } = this.props;

    const modifyBookingLink = this.modifyBookingLink();
    const showSeparator = modifyBookingLink || footer_content;

    const queryParams = new URLSearchParams(window.location.search);
    const bookingLanguage = queryParams.get('lang');
    return (
      <div className="Confirmation-Body">
        {this._renderTitle()}
        <div className="Confirmation-Body">
          {!this._isLiveBooking() && (
            <div>
              {this._renderRegularBody()}
              {custom_body && (
                <ConfirmationSection
                  className="contains-brand-link"
                  dangerouslySetInnerHTML={{ __html: custom_body }}
                />
              )}
              {custom_locations_enabled && !online && (
                <Location location={location} />
              )}
              {experience_link &&
                !isBookingAffiliate &&
                this._renderExperienceLink(bookingLanguage)}
              {!experience_link &&
                canAdditionalGuestsLink &&
                this.belowGuestLimit() && (
                  <AdditionalGuestsLink
                    heading={AdditionalGuestsLinkSettings.heading}
                    content={AdditionalGuestsLinkSettings.content}
                    buttonText={AdditionalGuestsLinkSettings.button_text}
                    bookingIdHash={bookingIdHash}
                    bookingLanguage={bookingLanguage}
                  />
                )}
              {showSeparator && <hr className="separator" />}
              {modifyBookingLink}
            </div>
          )}
          {footer_content}
        </div>
      </div>
    );
  },
});

export default ConfirmationAccepted;
